module.exports = __webpack_public_path__ + "ly.svg?27ae749c0846f8a5c2e256ed49faf819";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/ly.svg
// module id = 1226
// module chunks = 0